import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
	selector: "app-district-add-school-confirm-id",
	templateUrl: "./district-add-school-confirm-id.component.html",
	styleUrls: ["./district-add-school-confirm-id.component.css"],
})
export class DistrictAddSchoolConfirmIDComponent implements OnInit {
	constructor(private ref: DynamicDialogRef, private dialogConfig: DynamicDialogConfig) {}

	ngOnInit(): void {
		this.EnteredSchoolID = this.dialogConfig.data.SchoolID;
	}

	/////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////

	EnteredSchoolID: number;
	SchoolID: string;

	/////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////

	onAdd() {
		var SID = this.SchoolID;

		console.log(Number(SID) + " == " + Number(this.EnteredSchoolID) + "?");

		// School IDs match
		if (Number(SID) == Number(this.EnteredSchoolID)) {
			this.ref.close({
				Error: false,
				Success: true,
			});
		}
		// One of the School IDs were different
		else {
			this.ref.close({
				Error: true,
				Success: false,
			});
		}
	}

	onClose() {
		this.ref.close({
			Error: false,
			Success: false,
		});
	}

	/////////////////////////////////////////////////////////
}
